import Vue from 'vue';
import billingService from './../../../services/billing';
import store from './../../../store';

export default {
  data() {
    return {
      activeTab: 'plan',
      loading: true,
      invoiceDetails: false,
      plans: [],
      invoices: [
        {
          id: 1,
          subject: 'Subject 1',
          order: 'Order 1',
          invoice_date: 'Invoice Date 1',
          due_date: 'Due Date 1',
          account_name: 'Account Name 1',
          billing_address: 'Billing Address 1',
          plan_name: 'Plan 1',
          amount: '$15',
          description: 'Description 1',
          status: 1
        },
        {
          id: 2,
          subject: 'Subject 2',
          order: 'Order 2',
          invoice_date: 'Invoice Date 2',
          due_date: 'Due Date 2',
          account_name: 'Account Name 2',
          status: 1,
          billing_address: 'Billing Address 2',
          plan_name: 'Plan 2',
          amount: "$0",
          description: 'Description 2'
        },
        {
          id: 3,
          subject: 'Subject 3',
          order: 'Order 3',
          invoice_date: 'Invoice Date 3',
          due_date: 'Due Date 3',
          account_name: 'Account Name 3',
          status: 1,
          billing_address: 'Billing Address 3',
          plan_name: 'Plan 3',
          amount: '$95',
          description: 'Description 3'
        },
        {
          id: 4,
          subject: 'Subject 4',
          order: 'Order 4',
          invoice_date: 'Invoice Date 4',
          due_date: 'Due Date 4',
          account_name: 'Account Name 4',
          status: 0,
          billing_address: 'Billing Address 4',
          plan_name: 'Plan 4',
          amount: '$25',
          description: 'Description 4'
        },
        {
          id: 5,
          subject: 'Subject 5',
          order: 'Order 5',
          invoice_date: 'Invoice Date 5',
          due_date: 'Due Date 5',
          account_name: 'Account Name 5',
          status: 1,
          billing_address: 'Billing Address 5',
          plan_name: 'Plan 5',
          amount: '$25',
          description: 'Description 5'
        }
      ],
      invoiceItem: {}
    };
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
    VLoading : require('components/loading/loading.vue')
  },
  methods: {
    change_tab (tab) {
      let vm = this;
      vm.activeTab = tab;
      if(vm.activeTab){
        Vue.router.push({
          name: 'billing.index.tab',
          params: { tab: vm.activeTab }
        });
      }
    },
    change_plan(plan) {
      let vm = this;
      vm.loading = true;
      billingService.changePlan(plan, vm);
    },
    showDetail (invoice){
      let vm = this;
      vm.invoiceDetails = true;
      vm.invoiceItem = invoice;
      $(".panel-overlay").fadeIn();
      $(".ninja-btn,.panel").addClass("active");
      $(".panel-overlay").fadeIn();
      $(".pannel_sec_second").css({ "right": "-350px" });
    },
    closeDetailModal (){
      let vm = this;

      $(".ninja-btn, .panel").removeClass("active");
      $(".panel-overlay").fadeOut();
      $(".pannel_sec_second").css({ "right": "-350px"});
      vm.invoiceDetails = false;
      vm.invoiceItem = {};
    },
  },
  mounted() {
    let vm = this;
    if(vm.$route.params.tab){
      vm.change_tab (vm.$route.params.tab)
    }

    $(".panel-overlay" ).click(function() {
      vm.closeDetailModal();
    });

    billingService.getPlans(vm);
  },
  computed: {
    account: function () {
      return this.$store.state.account;
    }
  }
};



// WEBPACK FOOTER //
// ./src/app/pages/billing/index/billing.js